import domainSaga                   from '../app/domain/saga';
import { all }                      from 'redux-saga/effects';

export default function* rootSaga() {
    yield all([
        domainSaga()
    ])
}